import React from 'react'
import preloader from './preloader.svg'
import styles from './Preloader.module.css'

let Preloader = () => {
    return (
    <div className={styles.loading}>
        <img src={preloader} width={100} className={styles.image}/>
    </div>
    )
}

export default Preloader